// ── Recently opened from the palette ──────────────────────────────────────
// Per browser and per shell, a convenience only: ids of pages and actions,
// never a record's name, so nothing about the organisation's registers is kept
// in the browser. The ids are resolved against the current entries when the
// palette opens, so a page the person can no longer reach simply drops out.

const MAX_RECENT = 5;

function storageKey(scope: string): string {
  return `abacas.palette.recent.${scope}`;
}

export function readRecent(scope: string): string[] {
  try {
    const raw = window.localStorage.getItem(storageKey(scope));
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === "string").slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function rememberRecent(scope: string, id: string): void {
  try {
    const next = [id, ...readRecent(scope).filter((v) => v !== id)].slice(0, MAX_RECENT);
    window.localStorage.setItem(storageKey(scope), JSON.stringify(next));
  } catch {
    /* private window or blocked storage: the palette works without it */
  }
}
